'use client';
import { GoBack } from '@/components/go-back';
import { Filters } from '@/components/filter';
import { QuestionList } from '@/components/question-list';
import { useQuestion } from '@/hooks/useQuestion';
import { useState, useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

const SPOTLIGHT_QUESTIONS_LIMIT = 10;

export default function SpotlightQuestions() {
  const searchParams = useSearchParams();
  const categoryParam = searchParams.get('category');
  const [selectedFilters, setSelectedFilters] = useState<string[]>(
    categoryParam ? [categoryParam] : []
  );

  // Use the infinite query instead of the regular query
  const { getInfiniteQuestionsApi, getAllQuestions } = useQuestion({
    limit: SPOTLIGHT_QUESTIONS_LIMIT,
    categoryId: selectedFilters,
    type: 'TEASER',
  });

  // Get all questions from all pages
  const questions = getAllQuestions();
  const isLoading = getInfiniteQuestionsApi.isLoading;
  const isFetchingNextPage = getInfiniteQuestionsApi.isFetchingNextPage;
  const hasNextPage = getInfiniteQuestionsApi.hasNextPage;

  return (
    <section className="grid grid-cols-[300px_1fr] gap-12 p-8 max-w-5xl w-full mx-auto">
      <Filters
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        filterType="TEASER"
      />

      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-2">
          <GoBack />
          <h1 className="text-base font-bold text-[#24292E]">
            Spotlight Questions
          </h1>
        </div>
        {questions.length === 0 && !isLoading ? (
          <div className="flex items-center justify-center p-20">
            <p className="text-sm text-gray-500">
              No idea starter questions found.
            </p>
          </div>
        ) : (
          <QuestionList
            questions={questions}
            isLoading={isLoading}
            hideUserInfo
            hideReport
            // Add infinite scroll props
            isInfiniteScroll={true}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            fetchNextPage={getInfiniteQuestionsApi.fetchNextPage}
          />
        )}
      </div>
    </section>
  );
}
